import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip"

type Props = {
  text: JSX.Element,
  description: string
}

const ToolTipTitle = ({ description, text }: Props) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {text}
        </TooltipTrigger>
        <TooltipContent side="right" className="bg-white text-black">
          <p className="font-poppins text-xs tracking-wide">{description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default ToolTipTitle
